const $ = window.jQuery;

let s = {
	body : $('body'),
	push : $('.js-push'),

	pushMenuSwitch : 1140,

	touchLengthMinX : 26,
	touchLengthMaxY : 26,

	// pushMenu         : $('.js-push__menu'),
	pushMenuSelector : '.js-push__menu',

	// pushContent : $('.js-push__content'),
	pushContentSelector : '.js-push__content',

	// menuToggle         : $('.js-menu__toggle'),
	menuToggleSelector : '.js-menu__toggle',

	// menuClose         : $('.js-menu__close'),
	menuCloseSelector : '.js-menu__close',

	// pushLevelForward         : $('.js-menu__item--has-children > a'),
	// pushLevelForwardSelector : '.js-menu__item--has-children > a',
	// pushLevelForward         : $('.js-push__menu .menu-item-has-children > a'),
	pushLevelForwardSelector : '.js-push__menu .menu-item-has-children > span',

	// pushLevelBack         : $('.js-menu__back'),
	pushLevelBackSelector : '.js-menu__back',
};

function init() {
	events();
}

function events() {
	var touchStartX, touchStartY, touchEndX, touchEndY;

	$(window).on('load resize', function() {

		if (window.innerWidth < s.pushMenuSwitch && s.push.hasClass('push--active')) {
			s.body.addClass('no-scroll');
		} else {
			s.body.removeClass('no-scroll');
		}
	});

	s.body.on('touchmove', function(event) {

		/** iOS requires this to disable touch scroll */
		// if (s.body.hasClass('no-scroll')) {
		// 	event.preventDefault();
		// 	// $('html, body').css({
		// 	// 	'height'   : '100%',
		// 	// 	'overflow' : 'hidden',
		// 	// });
		// }
	});

	s.body.on('mousedown touchstart', s.pushMenuSelector, function(event) {

		touchStartX = event.originalEvent.pageX;
		touchStartY = event.originalEvent.pageY;

	})
	.on('mouseup touchend', s.pushMenuSelector, function(event) {

		touchEndX = event.originalEvent.pageX;
		touchEndY = event.originalEvent.pageY;

		const touchUp    = touchStartY < touchEndY;
		const touchRight = touchStartX < touchEndX;
		const touchDown  = touchStartY > touchEndY;
		const touchLeft  = touchStartX > touchEndX;

		const touchLengthX  = Math.abs(touchStartX - touchEndX);
		const touchLengthY  = Math.abs(touchStartY - touchEndY);

		/** swipe back */
		if (touchRight && (touchLengthX > s.touchLengthMinX) && (touchLengthY < s.touchLengthMaxY)) { // swipe direction && threshold
			s.push.find('.push__level--current:not(.push__level--top)').find(s.pushLevelBackSelector).trigger('click');
		}
		// else if (touchLeft && (touchLengthX > s.touchLengthMinX) && (touchLengthY < s.touchLengthMaxY)) { // swipe direction && threshold
		// 	// do something
		// }
	});

	s.body.on('click', s.menuToggleSelector, function(event) {
    event.preventDefault();

		s.body.toggleClass('no-scroll');
		s.push.toggleClass('push--active');
		s.push.find('.push__level--top')
			.addClass('push__level--active')
			.addClass('push__level--current');

	}).on('click', s.pushLevelForwardSelector, function(event) {
    event.preventDefault();

		s.push.find('.push__level--current')
			.removeClass('push__level--current');

		$(this).next('.push__level')
			.addClass('push__level--active')
			.addClass('push__level--current');

	}).on('click', s.pushLevelBackSelector, function(event) {
    event.preventDefault();

		const $thisLevel = $(this).closest('.push__level'); // this parent

		$thisLevel
			.removeClass('push__level--active')
			.removeClass('push__level--current')
			.closest('.push__level--active') // level parent
			.addClass('push__level--current');

		/** reset scroll */
		setTimeout(function() {
			// $thisLevel.scrollTop(0);
			$thisLevel.find('.push__level-inner')
				.scrollTop(0);
		}, 400); // transition

	}).on('click', s.menuCloseSelector, function(event) {
    event.preventDefault();

		s.push.find('.push__level--top')
			.addClass('push__level--active')
			.addClass('push__level--current');

		setTimeout(function() {

			/** reset scroll */
			s.push
				// .find('.push__level')
				// .scrollTop(0);
				.find('.push__level-inner')
				.scrollTop(0);

			/** reset active */
			s.push
				.find('.push__level--active')
				.removeClass('push__level--active');
		}, 400); // transition
	});
}

export {init as default};
